export default __webpack_public_path__ + "static/media/home-call-history-1.a5b0cbd9.svg";